import { useEffect, useState } from "react";
import { Loader2, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

const STEPS = ["Finding people…", "Researching the company…", "Working out the email pattern…", "Checking GitHub…", "Writing your outreach…"];

export const Progress = () => {
  const [i, setI] = useState(0);
  useEffect(() => { const t = setInterval(() => setI((x) => Math.min(x + 1, STEPS.length - 1)), 8000); return () => clearInterval(t); }, []);
  return (
    <div className="rounded-2xl border border-[#D4AF37]/30 bg-[#D4AF37]/5 p-6" data-testid="people-progress">
      <div className="flex items-center gap-3"><Loader2 className="h-5 w-5 animate-spin text-[#D4AF37]" /><p className="text-sm font-medium text-zinc-100" data-testid="people-progress-step">{STEPS[i]}</p></div>
      <div className="mt-4 flex gap-1.5">{STEPS.map((s, k) => <span key={s} className={cn("h-1 flex-1 rounded-full transition-colors duration-500", k <= i ? "bg-[#D4AF37]" : "bg-[#27272A]")} />)}</div>
      <p className="mt-3 text-xs text-zinc-500">This usually takes 30-45 seconds.</p>
    </div>
  );
};

export const SearchForm = ({ value, onChange, onSubmit, busy }) => {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  const ok = value.company_name.trim().length >= 2;
  return (
    <form onSubmit={(e) => { e.preventDefault(); if (ok && !busy) onSubmit(); }} className="space-y-3 rounded-2xl border border-[#27272A] bg-[#121214] p-4" data-testid="people-form">
      <div className="grid gap-3 sm:grid-cols-2">
        <Input value={value.company_name} onChange={set("company_name")} maxLength={80} placeholder="Company (required), e.g. Stripe" data-testid="people-company-input" />
        <Input value={value.role_keywords} onChange={set("role_keywords")} maxLength={120} placeholder="Role keywords, e.g. engineering manager" data-testid="people-role-input" />
        <Input value={value.person_name} onChange={set("person_name")} maxLength={80} placeholder="Person's name (optional)" data-testid="people-person-input" />
        <Input value={value.location_hint} onChange={set("location_hint")} maxLength={80} placeholder="Location (optional)" data-testid="people-location-input" />
      </div>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex flex-wrap gap-2">
        <div className="flex gap-1 rounded-full border border-[#27272A] bg-[#09090B] p-1 text-xs">
          {[["job_search", "Job search"], ["networking", "Networking"]].map(([k, l]) => <button type="button" key={k} onClick={() => onChange({ ...value, intent: k })} className={cn("rounded-full px-3 py-1", value.intent === k ? "bg-[#D4AF37] font-semibold text-black" : "text-zinc-400")} data-testid={`people-intent-${k}`}>{l}</button>)}
        </div>
        <div className="flex items-center gap-1 rounded-full border border-[#27272A] bg-[#09090B] p-1 text-xs">
          {[3, 5, 8].map((n) => <button type="button" key={n} onClick={() => onChange({ ...value, max_people: n })} className={cn("rounded-full px-3 py-1", value.max_people === n ? "bg-[#D4AF37] font-semibold text-black" : "text-zinc-400")} data-testid={`people-max-${n}`}>{n} people</button>)}
        </div>
        </div>
        <Button type="submit" disabled={!ok || busy} data-testid="people-search-button">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Search className="h-4 w-4" />}Find people</Button>
      </div>
    </form>
  );
};
